import { render, staticRenderFns } from "./PetHealth.vue?vue&type=template&id=b78e0b24&scoped=true&"
import script from "./PetHealth.vue?vue&type=script&lang=js&"
export * from "./PetHealth.vue?vue&type=script&lang=js&"
import style0 from "./PetHealth.vue?vue&type=style&index=0&id=b78e0b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78e0b24",
  null
  
)

export default component.exports